import type { GQL_ID } from '@@partner:types:graphql'
import type { BusinessProfile } from '@@partner:types:app'

import { gql, useQuery } from '@apollo/client'

import { SHORTCUT_BUSINESS_PROFILE_MANAGERS_FIELDS, SHORTCUT_BUSINESS_PROFILE_OWNER_FIELDS, SHORTCUT_BUSINESS_PROFILES_FIELDS, SHORTCUT_BUSINESS_PROFILES_ORDERS_FIELD, SHORTCUT_CUSTOMERS_FIELDS } from '@@partner:graphql/shortcuts'

export interface SingleBusinessProfileQuery {
  singleBusinessProfile: BusinessProfile
}
export interface SingleBusinessProfileQueryVariables {
  id?: GQL_ID
}

export const GQL_QUERY_SINGLE_BUSINESS_PROFILE = gql`
  query singleBusinessProfile (
    $id: ID!
  ) {
    singleBusinessProfile(id: $id) {
      ${SHORTCUT_BUSINESS_PROFILES_FIELDS}
      ${SHORTCUT_BUSINESS_PROFILES_ORDERS_FIELD}
      ${SHORTCUT_BUSINESS_PROFILE_MANAGERS_FIELDS}
      ${SHORTCUT_BUSINESS_PROFILE_OWNER_FIELDS}
    }
  }
`

export const useFetchSingleBusinessProfile = (
  variables: SingleBusinessProfileQueryVariables
) => {
  return useQuery<SingleBusinessProfileQuery, SingleBusinessProfileQueryVariables>(
    GQL_QUERY_SINGLE_BUSINESS_PROFILE,
    {
      variables,
      skip: !variables.id
    }
  )
}
